import styled from 'styled-components';

/* Functional components may house styles */
const HeaderStyled = styled.header`
    padding: 10px;
    position: fixed;
    top: 0;
    width: 100%;
    max-width: 1440px;
    z-index: 99;

    & > .container {
        display: flex;
        flex-direction: row;
        max-width: 1316px;
        margin: 0 auto;
        align-items: center;
    }

    &.header--transparent,
    &.header--solid {
        & + main.container {
            margin-top: 9.25rem;
        }
        background-image: linear-gradient(white, white);

        box-shadow: 0 2px 2px rgba(0, 0, 0, 0.2);
        margin-bottom: ${({ history }) => (history !== '/' ? '0' : ' 110px')};
    }
    .header__logo--mobile {
        image-rendering: auto;
        height: fit-content;
    }
    @media (min-width: 220px) and (max-width: 767px) {
        &.header--transparent,
        &.header--solid {
            & + main.container {
                margin-top: 3.2rem;
            }
        }
    }

    @media screen and (min-width: 768px) {
        &.header--transparent {
            background-image: linear-gradient(
                180deg,
                rgba(0, 0, 0, 0.5) 0%,
                rgba(0, 0, 0, 0) 90%
            );
            box-shadow: none;
            background-color: transparent;
            height: 180px;
            & + main.container {
                margin-top: 0;
            }
        }
    }

    .header--left,
    .header--right {
        flex: 1 1 auto;
    }

    .header__logo {
        margin-left: 20px;
        @media only screen and (width: 768px) {
            margin-left: 0px;
        }
        &--mobile {
            display: block;
            margin-left: 0;
        }
    }
`;

export default HeaderStyled;
